export default __webpack_public_path__ + "static/media/default.c2876ea8.png";